module.exports = __webpack_public_path__ + "static/media/alignment_output.441da4da.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/info/alignment_output.png
// module id = 2349
// module chunks = 0